import { useCallback } from 'react';

import { Resp, useApi } from '#/api/fetch-api';
import {
  AccountProfile,
  updateAccountProfile,
  UpdateAccountProfileReq,
} from '#/api/account';

import { AsyncResult, Result } from '#/utils/types';

interface AccountProfileUpdate
  extends Pick<AccountProfile, 'username' | 'is_username_private'> {}

export interface AccountProfileService {
  readonly update: (
    profile: AccountProfileUpdate,
  ) => AsyncResult<AccountProfile>;
}

export function useUpdate(): AccountProfileService['update'] {
  const [_, exec] = useApi(updateAccountProfile);

  const update = useCallback(
    async (profile: AccountProfileUpdate) => {
      const resp = await exec(prepareRequest(profile)).promise;
      return prepareResponse(resp);
    },
    [exec],
  );

  return update;
}

function prepareRequest(
  profile: AccountProfileUpdate,
): UpdateAccountProfileReq {
  return {
    username: profile.username,
    is_username_private: profile.is_username_private,
  };
}

function prepareResponse<T>(resp: Resp<T>): Result<T> {
  return resp.ok
    ? { ok: true, data: resp.data }
    : {
        ok: false,
        error: resp.error,
        reason: resp.message,
      };
}
